import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useContext} from 'react';

import {MainFilterContext} from '../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../provider/main-filter/main-filter-type';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';

import {fetchReviewsRatingByDate} from './reviews-rating-by-date-api';
import {ReviewsRatingByDateType} from './reviews-rating-by-date-type';

export function useReviewsRatingByDate(
    filter: ReviewsAndAnswersFilterStateType
): UseQueryResult<ReviewsRatingByDateType> {
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    return useQuery({
        queryKey: ['reviewsRatingByDate', filter, mainFilterKey],
        queryFn: async () => {
            return fetchReviewsRatingByDate(filter, mainFilterKey);
        },
        cacheTime: 0,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}
